
<template>
  <div class="infoTopBox">
    <div class="opBox">
      <!--友情链接-->
      <div class="infoTopBoxdiv">
        <div class="infoleft">
          <div class="infoshow">
            <a
              class="link"
              href="javascrip:void(0)"
              @click="showlink(infolinkItemData.url)"
              v-for="infolinkItemData in bottombox.link"
              :key="infolinkItemData.key"
            >
              <span :title="infolinkItemData.name">{{infolinkItemData.name}}</span>
            </a>
          </div>
        </div>
      </div>
      <!--企业信息-->
      <div class="infoBottomBox">
        <div class="infodiv">
          <div class="kingdeeinfo">{{bottombox.enterprise.introduce}}</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  methods: {
    showlink(showurl) {
      if(showurl!=''){
        window.open(showurl, "_blank");
      }
    }
  },
  computed: {
    bottombox: function() {
      return this.$store.state.malMainPageConfig.bottombox;
    }
  }
};
</script>

<style scoped lang="scss">
.infodiv {
  margin: 0 auto;
}
.infoTopBox {
  background: #202532;
  width: 100%;
  margin-top: 30px;
}
.opBox {
  background: #202532;
  width: 1200px;
  margin-top: 30px;
  margin: 0 auto;
}
.infoBottomBox {
  height: 70px;
  display: flex;
  flex-direction: row;
}
.infoTopBoxdiv {
  height: 94px;
  display: flex;
  margin: 0 auto;
}

.infoleft {
  margin: 0px auto;
}

.link {
  color: #ffffff;
  font-size: 16px;
  margin-left: 40px;
  align-items: center;
  text-decoration: none;
}

.infoshow {
  font-size: 16px;
  opacity: 0.7;
  margin-top: 50px;
}

.kingdeeinfo {
  color: #ffffff;
  font-size: 16px;
  opacity: 0.7;
  margin-top: 20px;
}
</style>
